import {
    DE_PSEUDO_CARE_PROVIDER_REQUEST,
} from 'Redux/Action';
import { ArrayContains } from 'ClientService';

export const isCareProviderDePseudoLoading = (state) =>
    ArrayContains(state.careProvider.openRequests, [
        DE_PSEUDO_CARE_PROVIDER_REQUEST,
    ]);